import { ChevronLeftIcon, ChevronRightIcon, CopyIcon } from "@chakra-ui/icons";
import { Button, HStack, Text, useToast } from "@chakra-ui/react";
import React from "react";
import { isMobile } from "react-device-detect";
import { decrementChapter, getChapter, incrementChapter, removeChapterAndVerse } from "./ParseString";
import { copyTextToClipboard } from "./helper";
import { useAppContext } from "./AppContext";

type FooterProps = {
  disableChapterRelatedButton: boolean;
  viewModeVerse: string;
  isAtMaxChapter: boolean;
};

const Footer: React.FC<FooterProps> = ({
  disableChapterRelatedButton,
  viewModeVerse,
  isAtMaxChapter,
}) => {
  const { copyWithVerse, isEnglish, query, handleChange, handleSubmit, versions } = useAppContext();
  const toast = useToast();
  const errorMsgs = ["No inputs!", "Verse not found!", "Typo existed!", "NOT FOUND"];
  const ChevronIconButtonStyle = {
    background: isMobile ? "transparent" : "initial",
    _hover: { background: isMobile ? "transparent" : "gray.300" },
    _active: { background: isMobile ? "transparent" : undefined },
    _focus: { background: isMobile ? "transparent" : undefined },
  };

  return (
    <HStack>
      <Button
        size={isMobile ? "sm" : "md"}
        {...ChevronIconButtonStyle}
        onClick={() => {
          const newQueryStr = decrementChapter(query);
          handleChange({ target: { value: newQueryStr } });
          handleSubmit(versions, newQueryStr);
        }}
        disabled={disableChapterRelatedButton || getChapter(query) === 1}
      >
        <ChevronLeftIcon boxSize={7} />
      </Button>
      <Button
        disabled={errorMsgs.includes(viewModeVerse) || !viewModeVerse}
        size={isMobile ? "sm" : "md"}
        colorScheme="teal"
        onClick={async () => {
          await copyTextToClipboard(viewModeVerse, toast, copyWithVerse, query);
        }}
      >
        <HStack spacing={"4px"}>
          <CopyIcon />
          <Text>{isEnglish ? "Copy" : "複製"}</Text>
        </HStack>
      </Button>
      <Button
        size={isMobile ? "sm" : "md"}
        onClick={() => {
          const newQueryStr = removeChapterAndVerse(query);
          handleChange({ target: { value: newQueryStr } });
          handleSubmit(versions, newQueryStr);
        }}
        disabled={disableChapterRelatedButton}
      >
        {isEnglish ? "Full Chapter" : "整章"}
      </Button>
      <Button
        size={isMobile ? "sm" : "md"}
        {...ChevronIconButtonStyle}
        onClick={() => {
          const newQueryStr = incrementChapter(query);
          handleChange({ target: { value: newQueryStr } });
          handleSubmit(versions, newQueryStr);
        }}
        disabled={disableChapterRelatedButton || isAtMaxChapter}
      >
        <ChevronRightIcon boxSize={7} />
      </Button>
    </HStack>
  );
};

export default Footer;
